import apis from "../common/apis";
import { HTTP_METHOD_GET } from "../utils/constant";
import { callApi } from "./fetchTools";

export default {
  getPolicy: (type: string) => {
    return callApi(HTTP_METHOD_GET, `${apis.public_policy}${type}`, null);
  },
};
